module.exports = __webpack_public_path__ + "img/app-download2.2d0ecf4c.png";